var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6429 11.4287C46.5469 11.4287 49.7143 14.5961 49.7143 18.5001V42.0716C49.7143 45.9756 46.5469 49.143 42.6429 49.143H38.0268V34.5337H42.913L43.6496 28.8372H38.0268V25.2033C38.0268 23.5582 38.4688 22.4533 40.8505 22.4533L43.846 22.4287V17.3461C43.3304 17.2725 41.538 17.1251 39.4755 17.1251C35.1295 17.1251 32.134 19.7769 32.134 24.6385V28.8372H27.2232V34.5337H32.134V49.143H19.0714C15.1674 49.143 12 45.9756 12 42.0716V18.5001C12 14.5961 15.1674 11.4287 19.0714 11.4287H42.6429Z",
    fill: "#3B579D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d3125d85f5d645100e1fbe8bf1430e92.svg";
export { ForwardRef as ReactComponent };